var O = Object.defineProperty;
var l = (m, e, t) => e in m ? O(m, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : m[e] = t;
var f = (m, e, t) => l(m, typeof e != "symbol" ? e + "" : e, t);
import "../../index-LgiXwH_r.js";
import { equalsWhenLowerCased as o, isNotNil as h } from "../../shared/utils.js";
import { StepParamsOneOfSchemaHandler as S } from "./step-params-one-of-schema-handler.js";
const u = {
  properties: {
    ofType: {
      type: "string"
    },
    parentType: {
      type: "string"
    },
    limit: {
      type: "number"
    },
    nextToken: {
      type: ["string", "null"]
    },
    parentId: {
      type: "string"
    },
    parentKey: {
      type: "string",
      enum: ["SECOND", "FIRST"]
    },
    sortOrder: {
      type: "string",
      enum: ["ASC", "DESC"]
    },
    namespace: {
      type: "string"
    }
  },
  required: ["ofType", "parentType", "parentId", "parentKey"]
};
class T {
  constructor(e) {
    f(this, "isGenericTypeStepHandler", !0);
    f(this, "stepParamsOneOfSchemaHandler");
    var p;
    this.apiDeclaration = e;
    const t = ["ofType", "namespace", "parentKey"], s = {
      oneOf: ((p = e.types) == null ? void 0 : p.map((r) => {
        var g, c;
        const a = r.id, i = (g = e.types) == null ? void 0 : g.find(
          (d) => o(
            d.name,
            r.parents.first ?? ""
          )
        ), n = (c = e.types) == null ? void 0 : c.find(
          (d) => o(
            d.name,
            r.parents.second ?? ""
          )
        );
        return {
          type: "object",
          properties: {
            ...u.properties,
            parentType: {
              type: "string",
              enumLabels: [
                i == null ? void 0 : i.name,
                n == null ? void 0 : n.name
              ].filter(h),
              enum: [i == null ? void 0 : i.id, n == null ? void 0 : n.id].filter(
                h
              )
            },
            ofType: {
              type: "string",
              enum: [a]
            }
          },
          required: u.required
        };
      })) ?? [],
      routingParams: ["ofType"]
    };
    this.stepParamsOneOfSchemaHandler = new S(
      s,
      t,
      !1,
      (r) => r.ofType
    ), this.apiDeclaration = e;
  }
  getFieldLogicLanguage(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldLogicLanguage(
      e,
      t
    );
  }
  getFieldLogicLanguageOptions(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldLogicLanguageOptions(
      e,
      t
    );
  }
  get schema() {
    return this.stepParamsOneOfSchemaHandler.schema;
  }
  getFields(e) {
    return this.stepParamsOneOfSchemaHandler.getFields(e);
  }
  validate(e) {
    return this.stepParamsOneOfSchemaHandler.validate(e);
  }
  getFieldValue(e, t) {
    return this.stepParamsOneOfSchemaHandler.getFieldValue(e, t);
  }
  getUpdatedParamsConfigState(e, t, s, p) {
    return this.stepParamsOneOfSchemaHandler.getUpdatedParamsConfigState(
      e,
      t,
      s,
      p
    );
  }
  getUpdatedState(e, t, s) {
    var p, r;
    if (t === "parentType") {
      const a = (p = this.apiDeclaration.types) == null ? void 0 : p.find(
        (d) => o(d.id, s)
      ), i = e.ofType, n = (r = this.apiDeclaration.types) == null ? void 0 : r.find(
        (d) => o(d.id, i)
      ), g = o(
        (n == null ? void 0 : n.parents.first) ?? "",
        a == null ? void 0 : a.name
      ), c = o(
        (n == null ? void 0 : n.parents.second) ?? "",
        a == null ? void 0 : a.name
      );
      if (g)
        return this.stepParamsOneOfSchemaHandler.getUpdatedState(
          {
            ...e,
            parentKey: "FIRST"
          },
          t,
          a == null ? void 0 : a.id
        );
      if (c)
        return this.stepParamsOneOfSchemaHandler.getUpdatedState(
          {
            ...e,
            parentKey: "SECOND"
          },
          t,
          a == null ? void 0 : a.id
        );
    }
    return this.stepParamsOneOfSchemaHandler.getUpdatedState(
      e,
      t,
      s
    );
  }
  getInitialState(e, t) {
    const s = t && "isGenericTypeStepHandler" in t ? t.getOfTypeValue(e) : void 0;
    return {
      namespace: "",
      ...s && { ofType: s }
    };
  }
  getOfTypeValue(e) {
    return e.ofType;
  }
}
export {
  T as ListTypeByParentStepHandler
};
